<template>
  <v-container fluid py-0 style="background-color: #E4E7EA;">
    <v-container class="pb-15 pt-10">
      <v-row>
        <v-col cols="12">
          <div class="font-weight-medium secondary--text section-title">
            Shema organizacije
          </div>
        </v-col>
        <v-col cols="12">
          <div class="primary--text">
            Na ovoj web stranici možete vidjeti
            <span class="font-weight-bold">shemu organizacije</span>.
          </div>
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="organisations"
            disable-sort
            class="primary--text"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:[`item.opis`]="{ item }">
              <v-menu left :key="item.naziv" max-width="500" offset-x>
                <template v-slot:activator="{ on }">
                  <v-btn class="accent elevation-0 px-6 text-none" v-on="on"
                    >Više</v-btn
                  >
                </template>

                <v-card>
                  <v-list two-line class="secondary--text">
                    <v-list-item>
                      <v-list-item-icon class="pr-4 mb-4">
                        <v-img
                          width="70px"
                          src="../../assets/sumit-logo.svg"
                          alt="SUM"
                        ></v-img>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title
                          class="secondary--text font-weight-medium"
                          >{{ item.naziv }}</v-list-item-title
                        >
                        <v-list-item-subtitle class="secondary--text">
                          <span class="font-weight-bold">LDAP naziv: </span>
                          <span class="d-block d-sm-inline">{{
                            item.LDAP_naziv
                          }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-divider></v-divider>

                  <v-card-text>
                    <strong class="secondary--text">Detaljan opis:</strong>
                    <br />
                    <div class="primary--text mt-2">{{ item.opis }}</div>
                  </v-card-text>
                </v-card>
              </v-menu>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <div v-if="item.status === 'obvezan'" class="red--text">
                {{ item.status }}
              </div>
              <div v-else class="green--text">
                {{ item.status }}
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  components: {},
  data: () => ({
    headers: [
      { text: "Naziv atributa", value: "naziv" },
      { text: "LDAP naziv", value: "LDAP_naziv" },
      { text: "Status", value: "status" },
      { text: "Frekvencija", value: "frekvencija" },
      { text: "Detalji", value: "opis" }
    ],
    organisations: [
      {
        naziv: "Naziv ustanove",
        LDAP_naziv: "o",
        status: "obvezan",
        frekvencija: "n",
        opis: "Puni, službeni naziv ustanove."
      },
      {
        naziv: "Identifikator ustanove",
        LDAP_naziv: "dc",
        status: "obvezan",
        frekvencija: "n",
        opis: "Identifikator ustanove (temelji se na DNS domeni ustanove)."
      },
      {
        naziv: "Brojčani identifikator ustanove",
        LDAP_naziv: "sumEduOrgUniqueNumber",
        status: "obvezan",
        frekvencija: "n",
        opis:
          "Vrijednost atributa je brojčani identifikator ustanove. Sintaksa: tip_identifikatora:<vrijednost> tip_identifikatora ima kontrolirani skup vrijednosti i one mogu biti: OIB, MBUST, RKDP, MZOS_SIFRA"
      },
      {
        naziv: "Poštanska Adresa",
        LDAP_naziv: "postalAdress",
        status: "obvezan",
        frekvencija: "n",
        opis:
          "Službena adresa koju je potrebno napisati na poštansku pošiljku poslanu ustanovi."
      },
      {
        naziv: "Mjesto (lokalitet) ",
        LDAP_naziv: "l",
        status: "obvezan",
        frekvencija: "n",
        opis: "Mjesto u kojem se nalazi ustanova."
      },
      {
        naziv: "Poštanski broj ",
        LDAP_naziv: "postalCode",
        status: "opcionalan",
        frekvencija: "n",
        opis:
          "Poštanski broj iz službene adrese zapisan prema službenoj poštanskoj normi."
      },
      {
        naziv: "Ulica i kućni broj ",
        LDAP_naziv: "street",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Ulica i kućni broj iz službene adrese."
      },
      {
        naziv: "Telefonski broj ",
        LDAP_naziv: "telephoneNumber",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Telefonski broj ustanove. "
      },
      {
        naziv: "Fax broj",
        LDAP_naziv: "facsimileTelephoneNumber",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Fax broj ustanove."
      },
      {
        naziv: "Broj mobilnog telefona",
        LDAP_naziv: "sumEduOrgMobile",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Broj mobilnog telefona ustanove."
      },
      {
        naziv: "Elektronička adresa ",
        LDAP_naziv: "sumEduOrgMail",
        status: "obvezan",
        frekvencija: "n",
        opis: "Službena elektronička adresa ustanove."
      },
      {
        naziv: "Tip ustanove",
        LDAP_naziv: "sumEduOrgType",
        status: "obvezan",
        frekvencija: "1",
        opis: "Tip ustanove prema kategorizaciji FMON."
      },
      {
        naziv: "Pripadnost ustanovi",
        LDAP_naziv: "sumEduOrgMember",
        status: "opcionalan",
        frekvencija: "1",
        opis:
          "Pripadnost nekoj ustanovi; npr. sveučilištu; vrijednost atributa je realm, odnosno DNS (Internet) domena krovne ustanove."
      },
      {
        naziv: "URL adresa ustanove",
        LDAP_naziv: "sumEduOrgURL",
        status: "opcionalan",
        frekvencija: "1",
        opis: "URL adresa web sjedišta ustanove."
      },
      {
        naziv: "URI adresa politike",
        LDAP_naziv: "sumEduOrgPolicyURI",
        status: "obvezan",
        frekvencija: "n",
        opis: "URI s oznakom; pokazuje na službenu politiku ustanove."
      },
      {
        naziv: "URI-tip ustanove",
        LDAP_naziv: "shacHomeOrganizationType",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Tip ustanove opisan URI-jem."
      }
    ]
  })
};
</script>
